import AuthLayout from "@container/layout/auth";
import AgentCalls from "@container/agent-calls";

export default function AgentCallsPage() {
    return (
        <AuthLayout>
            <AgentCalls />
        </AuthLayout>
    );
}
